import { AnimatePresence } from "framer-motion";
import { useState, useEffect } from "react";
import Navbar from "@/components/navbar";
import HeroSection from "@/components/hero-section";
import VideoHero from "@/components/video-hero";
import FeaturesSection from "@/components/features-section";
import ProductShowcase from "@/components/product-showcase";
import ProductsSection from "@/components/products-section";
import ProcessSection from "@/components/process-section";
import AboutSection from "@/components/about-section";
import StatsSection from "@/components/stats-section";
import GallerySection from "@/components/gallery-section";
import TestimonialsSection from "@/components/testimonials-section";
import BlogSection from "@/components/blog-section";
import NewsletterSection from "@/components/newsletter-section";
import ContactSection from "@/components/contact-section";
import Footer from "@/components/footer";
import FloatingActionButton from "@/components/floating-action-button";
import LoadingScreen from "@/components/loading-screen";
import ScrollProgress from "@/components/scroll-progress";

export default function Home() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen">
      <AnimatePresence>
        {isLoading && <LoadingScreen />}
      </AnimatePresence>
      
      <ScrollProgress />
      <Navbar />
      <HeroSection />
      <FeaturesSection />
      <ProductShowcase />
      <ProductsSection />
      <VideoHero />
      <ProcessSection />
      <AboutSection />
      <StatsSection />
      <GallerySection />
      <TestimonialsSection />
      <BlogSection />
      <NewsletterSection />
      <ContactSection />
      <Footer />
      <FloatingActionButton />
    </div>
  );
}
